<template>
	<button type="button" @click="CookieConsent.showPreferences()" v-if="!isMobileDevice">
		<IconCookies />
	</button>
</template>

<script setup lang="ts">
	import { computed } from "vue"
	import "vanilla-cookieconsent/dist/cookieconsent.css"
	import * as CookieConsent from "vanilla-cookieconsent"
	import config from "../components/cookieconsent-config"
	import IconCookies from "../icons/IconCookies.vue"
	import { useDeviceManager } from "../stores/deviceManager"
	document.documentElement.classList.add("cc--darkmode")
	import { onMounted } from "vue"
	const url = new URL(window.location.href)
	const deviceManager = useDeviceManager()

	const isMobileDevice = computed(
		// () => deviceManager.operatingSystem === "ios" || deviceManager.operatingSystem === "android"
		() => deviceManager.deviceInfo.platform !== "web"
	)

	onMounted(() => {
		const configs = config(url.searchParams.get("lang"))
		if (!isMobileDevice.value) {
			setTimeout(() => {
				CookieConsent.run(configs)
			}, 500)
		}
	})
</script>

<style lang="scss" scoped>
	button {
		position: fixed;
		bottom: 20px;
		right: 20px;
		z-index: 10;
		background-color: var(--red);
		color: #fff;
		border: none;
		padding: 5px;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		svg {
			fill: white;
			width: 35px;
			height: 35px;
		}
	}
</style>
